/**
 * HTTP Status Codes Configuration
 * Centralized configuration for HTTP status codes used in monitor notifications
 */

/**
 * 4xx Client Error status codes
 * Specific codes that should trigger HTTP alerts
 */
export const HTTP_STATUS_CODES_4XX = [
  400, 401, 403, 404, 405, 406, 407, 408, 409, 410, 411, 412, 413, 414, 415, 416, 417, 418, 421, 422, 423, 424, 425, 426, 428, 429, 431, 451,
] as const;

/**
 * 5xx Server Error status codes
 * Specific codes that should trigger HTTP alerts
 */
export const HTTP_STATUS_CODES_5XX = [
  500, 501, 502, 503, 504, 505, 506, 507, 508, 510, 511, 520, 521, 522, 523, 524, 525, 526, 527, 530,
] as const;

/**
 * All HTTP status codes (4xx and 5xx combined)
 * Used for default selections and options
 */
export const HTTP_STATUS_CODES = [
  ...HTTP_STATUS_CODES_4XX,
  ...HTTP_STATUS_CODES_5XX,
] as const;

/**
 * HTTP status codes as strings (for form values and API)
 */
export const HTTP_STATUS_CODES_4XX_STRINGS = HTTP_STATUS_CODES_4XX.map(c => c.toString());
export const HTTP_STATUS_CODES_5XX_STRINGS = HTTP_STATUS_CODES_5XX.map(c => c.toString());
export const HTTP_STATUS_CODES_STRINGS = HTTP_STATUS_CODES.map(c => c.toString());


